<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchParamCodigo"
                append-icon="search"
                label="Búsqueda por código"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchParamDescripcion"
                append-icon="search"
                label="Búsqueda por descripción"
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="6" md="6">
              <v-toolbar-title class="font-weight-black primary--text"
                >Reporte por Área del Presupuesto</v-toolbar-title
              >
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarBusqueda"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ mostrarBusquedas ? "search_off" : "search" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              mostrarBusquedas
                ? "Ocultar filtros de búsqueda"
                : "Mostrar filtros de búsqueda"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="exportarExcel"
                :loading="loadingExcel"
                :disabled="!id_presupuesto > 0"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> sim_card_download </v-icon>
              </v-btn>
            </template>
            <span>Exportar a Excel</span>
          </v-tooltip>
        </v-app-bar>

        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete
              outlined
              dense
              ref="id_presupuesto"
              v-model="id_presupuesto"
              :items="presupuestoList"
              :error-messages="errorMessages"
              item-text="descripcion"
              item-value="id"
              label="Presupuesto"
              required
            ></v-autocomplete>

            <v-text-field
              outlined
              reverse
              dense
              ref="mes_corte"
              v-model="mes_corte"
              :rules="[$rules.numero, $rules.requerido]"
              :error-messages="errorMessages"
              label="Mes de Corte"
              required
            ></v-text-field>
            <v-btn
              color="primary"
              class="white--text"
              @click="mostrarPeriodos"
              :loading="loading"
              :disabled="!id_presupuesto > 0"
            >
              Generar Reporte
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col> </v-col>
        </v-row>
        <v-sheet
          class="overflow-y-auto"
          :max-height="windowHeigth + this.auxHeigth"
          v-show="mostrarTabla"
        >
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - 200 + auxHeigth"
            :headers="headers"
            :items="dtCargos"
            mobile-breakpoint="0"
            sort-by="codigo"
            class="elevation-1"
            :loading="dtCargosLoad"
            loading-text="Cargando... Espere por favor"
            :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-text': 'Filas por página',
              'items-per-page-options': [-1, 100, 150, 200],
            }"
          >
            <template v-slot:[`header.real`]="{ header }">{{
              "Previus Period " + header.text.replace("real", gestionAntAnt)
            }}</template>
            <template v-slot:[`header.proy`]="{ header }">{{
              "Projected December " + header.text.replace("proy", gestionAnt)
            }}</template>
            <template v-slot:[`header.pant`]="{ header }">{{
              "Budget " + header.text.replace("pant", gestionAnt)
            }}</template>
            <template v-slot:[`header.pact`]="{ header }">{{
              "Budget " + header.text.replace("pact", gestionAct)
            }}</template>

            <template slot="body.append">
              <td colspan="1" align="right" class="font-weight-bold">
                Totales
              </td>
              <td align="right" class="font-weight-bold">{{ totals.real }}</td>
              <td align="right" class="font-weight-bold">{{ totals.proy }}</td>
              <td align="right" class="font-weight-bold">{{ totals.pant }}</td>
              <td align="right" class="font-weight-bold">{{ totals.pact }}</td>
            </template>

            <template v-slot:[`item.real`]="{ item }">
              <v-edit-dialog
                :return-value.sync="item.real"
                large
                @open="listarCargoArea(item.id_presup, 'C', 'REAL')"
                @cancel="limpiarDetalles()"
                @close="limpiarDetalles()"
                save-text=""
                cancel-text=""
              >
                <div>{{ item.real }}</div>

                <template v-slot:input>
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="exportarExcelDetalles"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> sim_card_download </v-icon>
                        </v-btn>
                      </template>
                      <span>Exportar a Excel</span>
                    </v-tooltip>
                  </v-app-bar>
                  <v-toolbar-title class="font-weight-black primary--text">{{
                    item.descripcion
                  }}</v-toolbar-title>

                  <v-data-table
                    dense
                    fixed-header
                    :height="300"
                    :headers="headersCentroCosto"
                    :items="dtCargosDetalles"
                    mobile-breakpoint="0"
                    sort-by="codigo"
                    class="elevation-1"
                    :loading="!dtCargosDetalles.length"
                    loading-text="Cargando... Espere por favor"
                    :header-props="{
                      'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                    }"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-text': 'Filas por página',
                      'items-per-page-options': [-1, 100, 150, 200],
                    }"
                  >
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-edit-dialog
                        :return-value.sync="item.cantidad"
                        large
                        @open="listarPersonaCargo(item.id_cargo, 'P', 'REAL')"
                        @cancel="limpiarDetallesPersona()"
                        @close="limpiarDetallesPersona()"
                        save-text=""
                        cancel-text=""
                      >
                        <div>{{ item.cantidad }}</div>

                        <template v-slot:input>
                          <v-app-bar color="white" elevate-on-scroll flat>
                            <v-spacer></v-spacer>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  large
                                  @click="exportarExcelDetPersona"
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark> sim_card_download </v-icon>
                                </v-btn>
                              </template>
                              <span>Exportar a Excel</span>
                            </v-tooltip>
                          </v-app-bar>
                          <v-toolbar-title
                            class="font-weight-black primary--text"
                            >{{ item.cargo_desc }}</v-toolbar-title
                          >

                          <v-data-table
                            dense
                            fixed-header
                            :height="300"
                            :headers="headersPersona"
                            :items="dtPersonasDetalles"
                            mobile-breakpoint="0"
                            sort-by="codigo"
                            class="elevation-1"
                            :loading="!dtPersonasDetalles.length"
                            loading-text="Cargando... Espere por favor"
                            :header-props="{
                              'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                            }"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-text': 'Filas por página',
                              'items-per-page-options': [-1, 100, 150, 200],
                            }"
                          >
                            <template v-slot:no-data>
                              <v-btn color="primary" @click="listarCargoArea"
                                >Reset</v-btn
                              >
                            </template>
                          </v-data-table>
                        </template>
                      </v-edit-dialog>
                    </template>

                    <template v-slot:no-data>
                      <v-btn color="primary" @click="listarCargoArea"
                        >Reset</v-btn
                      >
                    </template>
                  </v-data-table>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:[`item.pant`]="{ item }">
              <v-edit-dialog
                :return-value.sync="item.pant"
                large
                @open="listarCargoArea(item.id_presup, 'C', 'PANT')"
                @cancel="limpiarDetalles()"
                @close="limpiarDetalles()"
                save-text=""
                cancel-text=""
              >
                <div>{{ item.pant }}</div>

                <template v-slot:input>
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="exportarExcelDetalles"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> sim_card_download </v-icon>
                        </v-btn>
                      </template>
                      <span>Exportar a Excel</span>
                    </v-tooltip>
                  </v-app-bar>
                  <v-toolbar-title class="font-weight-black primary--text">{{
                    item.descripcion
                  }}</v-toolbar-title>
                  <v-data-table
                    dense
                    fixed-header
                    :height="300"
                    :headers="headersCentroCosto"
                    :items="dtCargosDetalles"
                    mobile-breakpoint="0"
                    sort-by="codigo"
                    class="elevation-1"
                    :loading="!dtCargosDetalles.length"
                    loading-text="Cargando... Espere por favor"
                    :header-props="{
                      'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                    }"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-text': 'Filas por página',
                      'items-per-page-options': [-1, 100, 150, 200],
                    }"
                  >
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-edit-dialog
                        :return-value.sync="item.cantidad"
                        large
                        @open="listarPersonaCargo(item.id_cargo, 'P', 'PANT')"
                        @cancel="limpiarDetallesPersona()"
                        @close="limpiarDetallesPersona()"
                        save-text=""
                        cancel-text=""
                      >
                        <div>{{ item.cantidad }}</div>

                        <template v-slot:input>
                          <v-app-bar color="white" elevate-on-scroll flat>
                            <v-spacer></v-spacer>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  large
                                  @click="exportarExcelDetPersona"
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark> sim_card_download </v-icon>
                                </v-btn>
                              </template>
                              <span>Exportar a Excel</span>
                            </v-tooltip>
                          </v-app-bar>
                          <v-toolbar-title
                            class="font-weight-black primary--text"
                            >{{ item.cargo_desc }}</v-toolbar-title
                          >

                          <v-data-table
                            dense
                            fixed-header
                            :height="300"
                            :headers="headersPersona"
                            :items="dtPersonasDetalles"
                            mobile-breakpoint="0"
                            sort-by="codigo"
                            class="elevation-1"
                            :loading="!dtPersonasDetalles.length"
                            loading-text="Cargando... Espere por favor"
                            :header-props="{
                              'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                            }"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-text': 'Filas por página',
                              'items-per-page-options': [-1, 100, 150, 200],
                            }"
                          >
                            <template v-slot:no-data>
                              <v-btn color="primary" @click="listarCargoArea"
                                >Reset</v-btn
                              >
                            </template>
                          </v-data-table>
                        </template>
                      </v-edit-dialog>
                    </template>

                    <template v-slot:no-data>
                      <v-btn color="primary" @click="listarCargoArea"
                        >Reset</v-btn
                      >
                    </template>
                  </v-data-table>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:[`item.pact`]="{ item }">
              <v-edit-dialog
                :return-value.sync="item.pact"
                large
                @open="listarCargoArea(item.id_presup, 'C', 'PACT')"
                @cancel="limpiarDetalles()"
                @close="limpiarDetalles()"
                save-text=""
                cancel-text=""
              >
                <div>{{ item.pact }}</div>

                <template v-slot:input>
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="exportarExcelDetalles"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> sim_card_download </v-icon>
                        </v-btn>
                      </template>
                      <span>Exportar a Excel</span>
                    </v-tooltip>
                  </v-app-bar>
                  <v-toolbar-title class="font-weight-black primary--text">{{
                    item.descripcion
                  }}</v-toolbar-title>
                  <v-data-table
                    dense
                    fixed-header
                    :height="300"
                    :headers="headersCentroCosto"
                    :items="dtCargosDetalles"
                    mobile-breakpoint="0"
                    sort-by="codigo"
                    class="elevation-1"
                    :loading="!dtCargosDetalles.length"
                    loading-text="Cargando... Espere por favor"
                    :header-props="{
                      'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                    }"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-text': 'Filas por página',
                      'items-per-page-options': [-1, 100, 150, 200],
                    }"
                  >
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-edit-dialog
                        :return-value.sync="item.cantidad"
                        large
                        @open="listarPersonaCargo(item.id_cargo, 'P', 'PACT')"
                        @cancel="limpiarDetallesPersona()"
                        @close="limpiarDetallesPersona()"
                        save-text=""
                        cancel-text=""
                      >
                        <div>{{ item.cantidad }}</div>

                        <template v-slot:input>
                          <v-app-bar color="white" elevate-on-scroll flat>
                            <v-spacer></v-spacer>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  large
                                  @click="exportarExcelDetPersona"
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark> sim_card_download </v-icon>
                                </v-btn>
                              </template>
                              <span>Exportar a Excel</span>
                            </v-tooltip>
                          </v-app-bar>
                          <v-toolbar-title
                            class="font-weight-black primary--text"
                            >{{ item.cargo_desc }}</v-toolbar-title
                          >

                          <v-data-table
                            dense
                            fixed-header
                            :height="300"
                            :headers="headersPersona"
                            :items="dtPersonasDetalles"
                            mobile-breakpoint="0"
                            sort-by="codigo"
                            class="elevation-1"
                            :loading="!dtPersonasDetalles.length"
                            loading-text="Cargando... Espere por favor"
                            :header-props="{
                              'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                            }"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-text': 'Filas por página',
                              'items-per-page-options': [-1, 100, 150, 200],
                            }"
                          >
                            <template v-slot:no-data>
                              <v-btn color="primary" @click="listarCargoArea"
                                >Reset</v-btn
                              >
                            </template>
                          </v-data-table>
                        </template>
                      </v-edit-dialog>
                    </template>

                    <template v-slot:no-data>
                      <v-btn color="primary" @click="listarCargoArea"
                        >Reset</v-btn
                      >
                    </template>
                  </v-data-table>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:[`item.proy`]="{ item }">
              <v-edit-dialog
                :return-value.sync="item.proy"
                large
                @open="listarCargoArea(item.id_presup, 'C', 'PROY')"
                @cancel="limpiarDetalles()"
                @close="limpiarDetalles()"
                save-text=""
                cancel-text=""
              >
                <div>{{ item.proy }}</div>

                <template v-slot:input>
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="exportarExcelDetalles"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> sim_card_download </v-icon>
                        </v-btn>
                      </template>
                      <span>Exportar a Excel</span>
                    </v-tooltip>
                  </v-app-bar>
                  <v-toolbar-title class="font-weight-black primary--text">{{
                    item.descripcion
                  }}</v-toolbar-title>
                  <v-data-table
                    dense
                    fixed-header
                    :height="300"
                    :headers="headersCentroCosto"
                    :items="dtCargosDetalles"
                    mobile-breakpoint="0"
                    sort-by="codigo"
                    class="elevation-1"
                    :loading="!dtCargosDetalles.length"
                    loading-text="Cargando... Espere por favor"
                    :header-props="{
                      'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                    }"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-text': 'Filas por página',
                      'items-per-page-options': [-1, 100, 150, 200],
                    }"
                  >
                    <template v-slot:[`item.cantidad`]="{ item }">
                      <v-edit-dialog
                        :return-value.sync="item.cantidad"
                        large
                        @open="listarPersonaCargo(item.id_cargo, 'P', 'PROY')"
                        @cancel="limpiarDetallesPersona()"
                        @close="limpiarDetallesPersona()"
                        save-text=""
                        cancel-text=""
                      >
                        <div>{{ item.cantidad }}</div>

                        <template v-slot:input>
                          <v-app-bar color="white" elevate-on-scroll flat>
                            <v-spacer></v-spacer>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  large
                                  @click="exportarExcelDetPersona"
                                  color="primary"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon dark> sim_card_download </v-icon>
                                </v-btn>
                              </template>
                              <span>Exportar a Excel</span>
                            </v-tooltip>
                          </v-app-bar>
                          <v-toolbar-title
                            class="font-weight-black primary--text"
                            >{{ item.cargo_desc }}</v-toolbar-title
                          >

                          <v-data-table
                            dense
                            fixed-header
                            :height="300"
                            :headers="headersPersona"
                            :items="dtPersonasDetalles"
                            mobile-breakpoint="0"
                            sort-by="codigo"
                            class="elevation-1"
                            :loading="!dtPersonasDetalles.length"
                            loading-text="Cargando... Espere por favor"
                            :header-props="{
                              'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                            }"
                            :footer-props="{
                              showFirstLastPage: true,
                              'items-per-page-text': 'Filas por página',
                              'items-per-page-options': [-1, 100, 150, 200],
                            }"
                          >
                            <template v-slot:no-data>
                              <v-btn color="primary" @click="listarCargoArea">
                                Reset
                              </v-btn>
                            </template>
                          </v-data-table>
                        </template>
                      </v-edit-dialog>
                    </template>

                    <template v-slot:no-data>
                      <v-btn color="primary" @click="listarCargoArea"
                        >Reset</v-btn
                      >
                    </template>
                  </v-data-table>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="listar">Cargar</v-btn>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
      <v-dialog v-model="dialogCargaExcel" max-width="40%">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga Masiva de Datos</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrarCarga"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="attach_file"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="guardarExcel"
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar archivo</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogActivacion" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción {{ estado == "A" ? "desactivará" : "activará" }} el
            elemento seleccionado.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogActivacion = false">Cancelar</v-btn>
            <div v-if="estado == 'A'">
              <v-btn color="primary" text @click="desactivar()"
                >Continuar</v-btn
              >
            </div>
            <div v-else>
              <v-btn color="primary" text @click="activar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogForm" max-width="500px" persistent>
        <v-card ref="form">
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="cerrar"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  :class="porcentajeCco === 100 ? 'd-none' : ''"
                >
                  <v-alert text outlined color="error" icon="warning">
                    No se ha asignado el 100% en Centros de Costo para el Cargo
                    seleccionado.
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="codigo"
                    v-model="codigo"
                    :readonly="!editarCodigo"
                    :rules="[$rules.requerido, $rules.max10]"
                    :error-messages="errorMessages"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    label="Código"
                    placeholder="Código"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    dense
                    ref="descripcion"
                    v-model="descripcion"
                    @keydown.enter.prevent="guardar"
                    @keydown.escape.prevent="cerrar"
                    :rules="[$rules.requerido, $rules.max50, $rules.min2]"
                    :error-messages="errorMessages"
                    label="Descripción"
                    placeholder="Descripción"
                    required
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_area"
                    v-model="id_area"
                    :items="areaList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    @change="selectSubarea"
                    item-text="descripcion"
                    item-value="id"
                    label="Área"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_subarea"
                    v-model="id_subarea"
                    :items="subareaList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Subárea"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_area_presupuesto"
                    v-model="id_area_presupuesto"
                    :items="areaPresupList"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    item-text="descripcion"
                    item-value="id"
                    label="Area Presupuesto"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    outlined
                    reverse
                    dense
                    ref="salario_ref"
                    v-model="salario_ref"
                    :rules="[$rules.numero]"
                    :error-messages="errorMessages"
                    label="Salario Referencial"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-show="esEditado">
                <v-card class="overflow-hidden">
                  <v-app-bar color="white" elevate-on-scroll flat>
                    <v-row v-if="mostrarBusquedas">
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          outlined
                          class="text-xs-center"
                          v-model="searchParamCodigo"
                          append-icon="search"
                          label="Búsqueda por código"
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          large
                          @click="agregarCentroCosto"
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark> add </v-icon>
                        </v-btn>
                      </template>
                      <span>Ingresar nuevo registro</span>
                    </v-tooltip>
                  </v-app-bar>
                  <v-sheet class="overflow-y-auto" :max-height="400">
                    <v-data-table
                      dense
                      fixed-header
                      :height="200"
                      :headers="headersCentroCosto"
                      :items="dtCargosDetalles"
                      mobile-breakpoint="0"
                      :items-per-page="50"
                      sort-by="codigo"
                      class="elevation-1"
                      :loading="!dtCargosDetalles.length"
                      loading-text="Cargando... Espere por favor"
                      :hide-default-footer="true"
                    >
                      <template v-slot:[`item.opciones`]="{ item }">
                        <v-btn
                          text
                          x-small
                          dark
                          color="primary"
                          @click="deleteItemCentroCosto(item)"
                        >
                          <v-icon x-small>delete</v-icon>
                        </v-btn>
                      </template>

                      <template v-slot:[`item.estado`]="{ item }">
                        <div v-if="item.estado == 'I'">
                          <v-btn
                            color="error"
                            x-small
                            text
                            dark
                            @click="abrirDialogActivacion(item)"
                          >
                            <v-icon x-small>block</v-icon>
                          </v-btn>
                        </div>
                        <div v-else>
                          <v-btn
                            color="success"
                            x-small
                            text
                            dark
                            @click="abrirDialogActivacion(item)"
                          >
                            <v-icon x-small>check</v-icon>
                          </v-btn>
                        </div>
                      </template>

                      <template v-slot:no-data>
                        <v-btn color="primary" @click="listarCargoArea"
                          >Reset</v-btn
                        >
                      </template>
                    </v-data-table>
                  </v-sheet>
                </v-card>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cerrar">Cancelar</v-btn>
            <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog dense v-model="dialogCentroCosto" max-width="500px">
        <v-card ref="formCentroCosto">
          <v-card-title>
            <span class="headline">Datos Centro de Costo</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    outlined
                    dense
                    ref="id_centro_costo"
                    v-model="id_centro_costo"
                    :items="CentroCostosList"
                    :readonly="editedIndexCco"
                    :rules="[]"
                    :error-messages="errorMessagesCentroCosto"
                    item-text="descripcion"
                    item-value="id"
                    label="Centro de Costo"
                    required
                  ></v-autocomplete>

                  <v-text-field
                    outlined
                    dense
                    ref="porcentaje"
                    v-model="porcentaje"
                    :rules="[$rules.numero, $rules.requerido]"
                    :error-messages="errorMessagesCentroCosto"
                    label="Porcentaje"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeCentroCosto"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="guardarCentroCosto"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogBorrarCentroCosto" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción borrará la asignación de Centro de Costo al
            cargo.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBorrarCentroCosto = false"
              >Cancelar</v-btn
            >
            <v-btn color="primary" text @click="eliminarCentroCosto()"
              >Continuar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import { json2excel, excel2json } from "js2excel";

export default {
  data() {
    return {
      //Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      //Declaración de arrays
      dtCargos: [],
      dtCargosLoad: false,
      dtCargosDetalles: [],
      dtPersonasDetalles: [],
      areaList: [],
      subareaList: [],
      areaPresupList: [],
      CentroCostosList: [],
      presupuestoList: [],
      //Declaración de variables de Dialog
      dialogForm: false,
      dialogCargaExcel: false,
      dialogActivacion: false,
      dialogCentroCosto: false,
      dialogBorrarCentroCosto: false,
      //Declaración de variables de formulario
      id: "",
      id_presupuesto: "",
      mes_corte: "8",
      codigo: "",
      descripcion: "",
      salario_ref: "",
      id_area: "",
      id_subarea: "",
      id_area_presupuesto: "",
      estado: "",
      porcentajeCco: "",
      porcentaje: 100,
      gestionAnt: 1999,
      gestionAct: 2000,
      gestionAntAnt: 2000,
      id_centro_costo: "",
      loadingExcel: false,
      loading: false,
      file: null,
      mostrarTabla: false,
      //Declaración de variables de tabla
      headers: [
        {
          text: "Area Presupuesto",
          value: "descripcion",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-3",
        },

        {
          text: "real",
          value: "real",
          align: "right",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "proy",
          value: "proy",
          align: "right",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "pant",
          value: "pant",
          align: "right",
          class: "primary white--text text-subtitle-3",
        },
        {
          text: "pact",
          value: "pact",
          align: "right",
          class: "primary white--text text-subtitle-3",
        },
      ],

      headersCentroCosto: [
        {
          text: "Area",
          value: "area_desc",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Subarea",
          value: "subarea_desc",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo_desc",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cantidad",
          value: "cantidad",
          align: "right",
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersPersona: [
        {
          text: "Código",
          value: "codigo_empleado",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Nombre",
          value: "nombre_completo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Ciudad",
          value: "ciudad",
          class: "primary white--text text-subtitle-2",
        },
      ],
      searchParamCodigo: "",

      esEditado: false,
      editarCodigo: false,
      editarCodigoCentroCosto: false,
      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,
      mostrarBusquedas: false,
      //variables de errrores
      valida: 0,
      errorMessages: "",
      errorMessagesCentroCosto: "",
      error: "",
      //variables de tamaño de pantalla

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight + this.auxHeigth,
      auxWidth: 0,
      auxHeigth: 0,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
        salario_ref: this.salario_ref,
        id_area: this.id_area,
        id_subarea: this.id_subarea,
        id_area_presupuesto: this.id_area_presupuesto,
      };
    },
    formCentroCosto() {
      return {
        id_centro_costo: this.id_centro_costo,
        porcentaje: this.porcentaje,
      };
    },

    totals() {
      const totals = this.dtCargos.reduce(
        (acc, d) => {
          acc.real += d.real;
          acc.proy += d.proy;
          acc.pant += d.pant;
          acc.pact += d.pact;

          return acc;
        },
        {
          real: 0,
          proy: 0,
          pant: 0,
          pact: 0,
        }
      );
      //totals.proy = totals.proy.toFixed(1) //para agregar decimales
      return totals;
    },
  },

  watch: {
    dialogForm(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
      this.errorMessagesCentroCosto = "";
    },
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')

    this.selectPresupuesto();
    this.selectArea();
    this.selectAreaPresup();
    this.selectCentroCosto();
  },

  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    listar() {
      let me = this;
      me.dtCargosLoad = true;
      axios
        .get(
          "api/reportes/listarVistaRepCantAreaPresupuesto/" + me.id_presupuesto
        )
        .then(function (response) {
          me.dtCargos = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight + me.auxHeigth;
          me.dtCargosLoad = false;
        })
        .catch(function (error) {
          me.dtCargosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    selectPresupuesto() {
      let me = this;
      axios
        .get("api/presupuestos/select")
        .then(function (response) {
          me.presupuestoList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listarCargoArea(idAreaPresup, agrupacion, origen) {
      let me = this;
      me.loading = true;
      axios
        .get(
          "api/reportes/listarVistaRepCantAreaPresupDetalle/" +
            me.id_presupuesto +
            "/" +
            idAreaPresup +
            "/" +
            agrupacion +
            "/" +
            origen
        )
        .then(function (response) {
          me.mostrarPorcentaje();
          me.dtCargosDetalles = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarPersonaCargo(idAreaPresup, agrupacion, origen) {
      let me = this;
      me.loading = true;
      axios
        .get(
          "api/reportes/listarVistaRepCantAreaPresupDetalle/" +
            me.id_presupuesto +
            "/" +
            idAreaPresup +
            "/" +
            agrupacion +
            "/" +
            origen
        )
        .then(function (response) {
          me.mostrarPorcentaje();
          me.dtPersonasDetalles = response.data;
          me.loading = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarPorcentaje() {
      let me = this;
      axios
        .get("api/cargo_centros/mostarPorcentaje/" + this.id)
        .then(function (response) {
          me.porcentajeCco = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectSubarea() {
      let me = this;
      axios
        .get("api/subareas/select/" + this.id_area)
        .then(function (response) {
          me.subareaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectArea() {
      let me = this;
      axios
        .get("api/areas/select")
        .then(function (response) {
          me.areaList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectAreaPresup() {
      let me = this;
      axios
        .get("api/area_presupuestos/select")
        .then(function (response) {
          me.areaPresupList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCentroCosto() {
      let me = this;
      axios
        .get("api/centro_costos/select")
        .then(function (response) {
          me.CentroCostosList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listar();
    },

    abrirDialogActivacion(item) {
      this.id = item.id;
      this.dialogActivacion = true;
      this.estado = item.estado;
    },

    mostrarPeriodos() {
      let me = this;
      var aux;
      var arreglo;
      me.mostrarTabla = true;
      me.boolReporte = false;
      axios
        .get("api/reportes/gestionActual/" + me.id_presupuesto)
        .then(function (response) {
          aux = response.data;
          arreglo = aux.split(",");

          me.gestionAct = arreglo[0];
          me.gestionAnt = arreglo[1];
          me.gestionAntAnt = me.gestionAnt - 1;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
      this.windowWidth = window.innerWidth;
      this.windowHeigth = window.innerHeight;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    cerrarCarga() {
      this.dialogCargaExcel = false;
      this.limpiarCargaExcel();
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },
    closeCentroCosto() {
      this.dialogCentroCosto = false;
      this.limpiarCentroCosto();
    },
    editar(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.salario_ref = item.salario_ref;
      this.id_area = item.id_area;
      this.id_subarea = item.id_subarea;
      this.id_area_presupuesto = item.id_area_presupuesto;
      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogForm = true;
      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada

      this.selectSubarea();
      this.listarCargoArea();
    },
    agregar() {
      this.editarCodigo = true;
      this.dialogForm = true;
    },
    agregarCentroCosto() {
      this.editarCodigoCentroCosto = true;
      this.dialogCentroCosto = true;
    },

    cerrar() {
      this.dialogForm = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.salario_ref = "";
      this.id_area = "";
      this.id_subarea = "";
      this.id_area_presupuesto = "";
      this.esEditado = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    limpiarCentroCosto(item) {
      this.id_centro_costo = "";
      this.id_cargo = "";
      this.porcentaje = 100;
      this.editedIndexCco = false;
    },
    limpiarDetalles() {
      this.dtCargosDetalles = [];
    },
    limpiarDetallesPersona() {
      this.dtPersonasDetalles = [];
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.esEditado) {
        //codigo para editar
        let me = this;
        axios
          .put("api/cargos/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,
            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/cargos/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            id_subarea: me.id_subarea,
            id_area_presupuesto: me.id_area_presupuesto,
            salario_ref: me.salario_ref,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.cerrar();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    exportarExcel() {
      let me = this;
      me.loadingExcel = true;
      axios({
        url:
          "api/reportes/ExportarExcelAreaPresupPrincipal/" +
          this.id_presupuesto,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "ReporteAreaPresupuesto - " + Date.now().toString() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.loadingExcel = false;
        me.$store.dispatch("setSnackbar", {
          text: "Excel generado exitosamente",
          color: "success",
        });
      });
    },

    exportarExcelDetalles() {
      let me = this;
      try {
        json2excel({
          data: me.dtCargosDetalles,
          name: "DetalleCargos",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },
    exportarExcelDetPersona() {
      let me = this;
      try {
        json2excel({
          data: me.dtPersonasDetalles,
          name: "DetallePersona",
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error(e);
      }
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/cargos/cargarExcel/" + me.usuario, formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.cerrarCarga();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarCentroCosto() {
      this.validaCentroCosto = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formCentroCosto).forEach((f) => {
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaCentroCosto += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaCentroCosto += 1;
        }
      });
      return this.validaCentroCosto;
    },

    activar() {
      let me = this;
      axios
        .put("api/cargos/activar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar() {
      let me = this;
      axios
        .put("api/cargos/desactivar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogActivacion = false;
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    deleteItemCentroCosto(item) {
      this.id_centro_costo = item.id_centro_costo;
      this.dialogBorrarCentroCosto = true;
    },
    eliminarCentroCosto() {
      let me = this;

      axios
        .delete(
          "api/cargo_centros/EliminarCargoCentro/" +
            me.id +
            "/" +
            me.id_centro_costo,
          {}
        )
        .then(function (response) {
          me.listarCargoArea();
          me.$store.dispatch("setSnackbar", {
            text: "Centro de Costo eliminado exitosamente.",
            color: "success",
          });
          me.dialogBorrarCentroCosto = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    guardarCentroCosto() {
      if (this.validarCentroCosto() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexCco) {
        let me = this;
        axios
          .put("api/cargo_centros/actualizar", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoArea();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro actualizado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/cargo_centros/crear", {
            id_cargo: me.id,
            id_centro_costo: me.id_centro_costo,
            porcentaje: me.porcentaje,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeCentroCosto();
            me.listarCargoArea();
            me.limpiarCentroCosto();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    redondear(numero, decimales) {
      let number = numero;
      let arreglo = 10 ** decimales;
      let total = Math.round(arreglo * number) / arreglo;

      return total;
    },

    filtroCodigo(value) {
      // Si el filtro no tiene valor, evitamos el filtro.
      if (!this.searchParamCodigo) {
        return true;
      }
      // Verificar el valor del ciclo actual, si contiene parcialmente la palabra buscada
      return value.toLowerCase().includes(this.searchParamCodigo.toLowerCase());
    },
  },
};
</script>
